import { gql } from '@apollo/client';

export const SP_DASHBOARD_OUTCOMES = gql`
  query DashboardOutcomes($input: FilterArgs) {
    dashboardOutcomes(input: $input) {
      id
      name
      teacherCount
      learnerCount
      beneficiaryCount
      mathsPassRate
      sciencePassRate
      englishPassRate
    }
  }
`;
